import { useState } from 'react';
import { TaskPage } from '../../../components/workbook/TaskPage';
import { Checkbox, TextArea } from '../../../components/workbook/forms';
import { Callout } from '../../../components/workbook/Callout';

const criteriaOptions = [
  'advances one of our 1–3 named outcomes this quarter (list them)',
  'creates customer value we can observe within 30 days',
  'we can ship a meaningful slice in ≤ 2 weeks',
  "we're uniquely positioned (comparative advantage)",
  'reduces a critical risk / removes a constraint',
  'regulatory/compliance/security required',
  'we have a clear DIBB (data / insight / belief / bet) or testable hypothesis',
  'saying yes means saying no to ________ for 30 days'
];

export default function DecisionCriteriaPage() {
  const [selectedCriteria, setSelectedCriteria] = useState<Record<string, boolean>>({});
  const [outcomes, setOutcomes] = useState('');
  const [customCriteria, setCustomCriteria] = useState('');

  const toggleCriterion = (index: number) => {
    setSelectedCriteria({ ...selectedCriteria, [index]: !selectedCriteria[index] });
  };

  const selectedCount = Object.values(selectedCriteria).filter(Boolean).length;

  return (
    <TaskPage
      phase="decide"
      title="Decision Criteria"
      pageNumber={4}
      instruction="When everything feels urgent, say yes only if… Pick up to five criteria."
      whyItMatters="Explicit criteria help novices avoid expert blind spots and lower decision friction later. Keep wording plain; test labels for clarity."
      coachRail={{
        timing: "12 minutes",
        tips: "Show one real example that passes and one that fails; model 'good enough' criteria and move on (avoid rabbit holes).",
        debrief: "Which criteria will you use most? Which feels hardest to apply?"
      }}
    >
      <div className="space-y-6">
        <div className="bg-[var(--surface)] p-6">
          <h3 className="text-lg font-semibold text-[var(--text-pri)] mb-4">Pick up to five criteria</h3>
          <div className="space-y-3">
            {criteriaOptions.map((criterion, index) => (
              <label key={index} className="flex items-start gap-3 cursor-pointer">
                <Checkbox
                  checked={selectedCriteria[index] || false}
                  onChange={() => toggleCriterion(index)}
                  label=""
                  disabled={selectedCount >= 5 && !selectedCriteria[index]}
                />
                <span className="text-[var(--text-sec)] flex-1">
                  {criterion === 'advances one of our 1–3 named outcomes this quarter (list them)' ? (
                    <span>
                      advances one of our 1–3 named outcomes this quarter
                      {selectedCriteria[index] && (
                        <TextArea
                          value={outcomes}
                          onChange={(e) => setOutcomes(e.target.value)}
                          placeholder="List them here..."
                          rows={2}
                          className="mt-2"
                        />
                      )}
                    </span>
                  ) : (
                    criterion
                  )}
                </span>
              </label>
            ))}
          </div>
          {selectedCount >= 5 && (
            <p className="text-sm text-[var(--mustard)] mt-3">You've selected 5 criteria. Uncheck one to add another.</p>
          )}
        </div>

        <div className="bg-[var(--slate-dim)] border border-[var(--slate)] p-6">
          <h3 className="text-lg font-semibold text-[var(--text-sec)] mb-4">Add your own (2 lines max)</h3>
          <TextArea
            label="Custom criteria"
            value={customCriteria}
            onChange={(e) => setCustomCriteria(e.target.value)}
            placeholder="Add your own criteria..."
            rows={2}
          />
        </div>

        <Callout type="tip" phase="decide">
          <p className="text-sm">Keep it simple. Pick the 3-5 criteria that matter most to you. You can refine these later.</p>
        </Callout>
      </div>
    </TaskPage>
  );
}






